import { stdObject } from "../../../../data/types/stdObject";

export const updateStationaryItem = (
  code: number,
  values: stdObject,
  params: stdObject,
) => {
  const { staValues, setStaValues } = params;
  const index = staValues.parts.findIndex((e: stdObject) => e.NUMPAR === code);
  if (index > -1) {
    staValues.parts[index] = { ...staValues.parts[index], ...values };
    setStaValues({ ...staValues });
  }
  return true;
};
